<template>
    <!--/* popin détails de la variation */-->
    <ob1-popin-modal2
        :id="popinModal.id"
        :aria-labelledby="popinModal.label"
        :show-close-button="popinModal.showCloseButton"
    >
        <h4 id="modalTitle">
            {{ title }}
        </h4>
        <div class="row pt-2 text-center text-md-start">
            <div id="priceBlock" class="col-12 col-md-6">
                <ob1-prix-offre
                    :duration="priceBlock.prixDTO.duration"
                    :initial-price="priceBlock.prixDTO.initialPrice"
                    :price="priceBlock.prixDTO.price"
                    :price-details="priceBlock.prixDTO.priceDetails"
                    :show-by-month="priceBlock.prixDTO.showByMonth"
                    :show-from="priceBlock.prixDTO.showFrom"
                    :show-promo-duration="priceBlock.prixDTO.showPromoDuration"
                    :price-label="priceBlock.priceLabel"
                    custom-promo-duration="text-gray3 d-inline-block"
                    custom-commitment="text-gray3"
                />
            </div>
            <div id="additionalInfosBlock" class="col-12 col-md-6 mt-1">
                <div v-for="(info, index) in additionalInfosBlock" :key="index">
                    <span class="text-gray3 d-block" v-html="info" />
                </div>
            </div>
        </div>
        <div id="guaranteesBlock" class="row pt-2">
            <guarantees :dto="guaranteesBlock" />
        </div>
        <div v-if="contractualDocumentsBlock.contractualDocuments.length > 0" id="contractualDocumentsBlock" class="pt-2">
            <span class="mb-1" v-html="contractualDocumentsBlock.title" />
            <contractual-documents
                :contractual-documents="contractualDocumentsBlock.contractualDocuments"
                :web-view="contractualDocumentsBlock.isWebview"
            />
        </div>
        <div class="d-flex justify-content-center my-2 mb-0">
            <ob1-boutons
                :label="buttonLabel"
                :is-button="true"
                :is-disabled="buttonUrl === null"
                :data-oevent-category="buttonTrackZone"
                data-oevent-action="ajouter_cette_assurance"
                :data-oevent-label="buttonTrackCible"
                is-primary
                @ob1-boutons-click="goToUrl"
            />
        </div>
    </ob1-popin-modal2>
</template>

<script>
import ContractualDocuments from "./ContractualDocuments.vue";
import Guarantees from "./Guarantees.vue";

export default {
    name: "VariationDetailsPopin",
    components: {Guarantees, ContractualDocuments},
    props: {
        dto: {
            type: Object,
            required: true
        },
        buttonTrackZone: {
            type: String,
            required: true
        },
        buttonTrackCible: {
            type: String,
            required: true
        }
    },
    computed: {
        popinModal() {
            return this.dto.popinModal;
        },
        title() {
            return this.dto.title;
        },
        guaranteesBlock() {
            return this.dto.guaranteesBlock;
        },
        contractualDocumentsBlock() {
            return this.dto.contractualDocumentsBlock;
        },
        additionalInfosBlock() {
            return this.dto.additionalInfosBlock;
        },
        priceBlock() {
            return this.dto.priceBlock;
        },
        buttonLabel() {
            return this.dto.buttonLabel;
        },
        buttonUrl() {
            return this.dto.buttonUrl;
        }
    },
    methods: {
        goToUrl(){
            window.location = this.dto.buttonUrl
        }
    }
}
</script>
